export const TOUR_API = "tour-api/";
export const TOUR_ROUTE = "tour-route/";
export const TOUR_API_DURATION = 'tour-api/duration/'
export const TOUR_API_DEFAULT_PLACES     = 'tour-api/default-places/'
